import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import CommonHeader from '../components/Headers/CommonHeader';
import { userAppContext } from '../context/Context';
import PaymentSuccessService from '../services/PaymentSuccessService';

const PaymentSuccess = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [sessionId, setSessionId] = useState(null);
  const [isRefreshing, setIsRefreshing] = useState(true);
  const { setUser, setGroups } = userAppContext();

  useEffect(() => {
    const session_id = searchParams.get('session_id');
    if (session_id) {
      setSessionId(session_id);

      PaymentSuccessService.refreshUserSession(setUser, setGroups).finally(() => {
        setIsRefreshing(false);
      });
    } else {
      setIsRefreshing(false);
    }
  }, [searchParams, setUser, setGroups]);

  const handleContinue = () => {
    navigate('/Profile-area');
  };

  return (
    <React.Fragment>
      <Helmet>
        <title>Payment Successful - DISGENET</title>
        <meta name="description" content="Your payment has been processed successfully." />
      </Helmet>
      <CommonHeader />

      <div className="container mx-auto px-4 py-8 text-center">
        <div className="max-w-md mx-auto bg-white rounded-lg shadow-lg p-8">
          <div className="mb-6">
            <i className="bi bi-check-circle-fill text-green-500 text-6xl"></i>
          </div>

          <h1 className="text-2xl font-bold text-gray-800 mb-4">Payment Successful!</h1>

          <p className="text-gray-600 mb-6">
            Thank you for your purchase. Your payment has been processed successfully.
            {isRefreshing && " We're updating your account..."}
          </p>

          {isRefreshing && (
            <div className="mb-4">
              <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500 mx-auto"></div>
              <p className="text-sm text-gray-500 mt-2">Updating your account...</p>
            </div>
          )}

          {!isRefreshing && (
            <div className="mb-4">
              <i className="bi bi-check-circle text-green-500 text-3xl"></i>
              <p className="text-sm text-green-600 mt-2 font-semibold">Your account has been updated!</p>
            </div>
          )}

          <div className="space-y-4">
            <button
              onClick={handleContinue}
              disabled={isRefreshing}
              className={`btn-gradient-blue w-full py-3 px-6 rounded-lg font-semibold ${
                isRefreshing ? 'opacity-50 cursor-not-allowed' : ''
              }`}
            >
              {isRefreshing ? 'Please wait...' : 'Go to Profile'}
            </button>

            <p className="text-sm text-gray-500">You will receive a confirmation email shortly.</p>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default PaymentSuccess;
